import Image from "next/image"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

import { HeroIcon } from "./icons/hero-icon"
import { ImproveIcon } from "./icons/improve-icon"
import { LevelUpIcon } from "./icons/level-up-icon"
import { SynergyIcon } from "./icons/synergy-icon"
import { LightBorder } from "./light-border"

export function AbilitiesSection() {
  return (
    <Box className="relative md:mb-4 md:px-8 mx-auto w-full overflow-hidden lg:overflow-visible mb-6 lg:mb-15">
      <Box className="hidden md:flex absolute w-[400px] h-[400px] left-[-300px] top-[30%] lg:left-[-400px] lg:top-[200px] bg-[#AC28DA] lg:w-[600px] lg:h-[600px] rounded-full blur-[100px]" />
      <Box className="hidden md:flex absolute w-[400px] h-[400px] right-[-300px] top-[30%] lg:right-[-400px] lg:top-[200px] bg-[#AC28DA] lg:w-[600px] lg:h-[600px] rounded-full blur-[100px]" />

      <Box
        full
        className="relative flex-1 w-full md:flex-row md:justify-between md:items-center md:bg-[url(/images/pages/bot-3d/abilities-section/bot-3d.png)] md:bg-contain md:bg-center md:bg-no-repeat"
      >
        <Box className="order-1 md:max-w-[300px] xl:max-w-[480px] left-0 justify-between h-full">
          <Box className="mb-4 md:mb-0">
            <Text as="h2" className="uppercase text-center md:text-left lg:text-[64px] lg:leading-[64px] mb-4 lg:mb-10">
              More than just an avatar
            </Text>

            <Text className="px-4 md:px-0 lg:text-[24px] lg:leading-[38px] text-center md:text-left">
              3D Cryptobots will be playable in the Cryptobots game as heroes
            </Text>
          </Box>
          <Box row className="mx-auto md:mx-0">
            <Box center>
              <Box className={`relative w-[117px] h-[44px] -bottom-[5px]`} />
              <Box center className="relative h-[192px] w-[128px] rounded-2xl bg-white/5">
                <LightBorder className="absolute -top-[5px] rotate-180 lg:w-[144px]" />
                <Box className="lg:w-[191px] lg:h-[160px]">
                  <Image
                    src="/images/pages/bot-3d/abilities-section/team-3d.png"
                    alt="bot team 3d"
                    width={191}
                    height={160}
                  />
                </Box>
                <LightBorder className="absolute -bottom-[5px] lg:w-[144px]" />
              </Box>
              <Box className={`relative w-[117px] h-[44px] -top-[5px]`} />
            </Box>
          </Box>

          <Box className="text-center md:text-left">
            <Text as="h3" className="uppercase text-[24px] leading-[24px] lg:text-[32px] lg:leading-[32px] mb-4">
              more bots — more value
            </Text>
            <Text className="px-4 md:px-0 lg:text-[16px] lg:leading-[26px]">
              3D Bots are not identical and have different bonuses - you will need several 3D Bots to open all the
              possible in-game benefits
            </Text>
          </Box>
        </Box>

        <Box className="order-2 -z-1 flex-1 md:hidden">
          <Box center full>
            {/* <Box className="w-[100%] md:w-[50%] md:justify-center"> */}
            <Image
              src="/images/pages/bot-3d/abilities-section/bot-3d.png"
              alt="bot 3d"
              objectFit="contain"
              width={1275}
              height={1275}
            />
            {/* </Box> */}
          </Box>
        </Box>

        <Box className="order-3 md:max-w-[300px] xl:max-w-[400px] right-0 md:gap-[48px] text-white px-4 md:px-0">
          <Box row>
            <Box className="mr-4">
              <Box center className="rounded-lg  w-[44px] h-[44px] lg:w-[56px] lg:h-[56px] bg-white/5">
                <LevelUpIcon />
              </Box>
            </Box>
            <Box>
              <Box className="mb-4 mt-3 uppercase font-bold text-[24px] leading-[24px] lg:text-[32px] lg:leading-[32px]">
                LEVEL UP
              </Box>
              <Box className="lg:text-[14px] lg:leading-[22px]">
                Choose a weapon to further spec your hero to whatever role you see fits. Level up to shift the battle in
                your favour in one swift move!
              </Box>
            </Box>
          </Box>
          <Box row className="mt-8 md:mt-0">
            <Box className="mr-4">
              <Box center className="rounded-lg  w-[44px] h-[44px] lg:w-[56px] lg:h-[56px] bg-white/5">
                <ImproveIcon />
              </Box>
            </Box>
            <Box>
              <Box className="mb-4 mt-3 uppercase font-bold text-[24px] leading-[24px] lg:text-[32px] lg:leading-[32px]">
                improve
              </Box>
              <Box className="lg:text-[14px] lg:leading-[22px]">
                Heroes are vital on and off the battlefield: they are your ultimate edge for faster resource mining,
                improved repairs and other strategic activities.
              </Box>
            </Box>
          </Box>
          <Box row className="mt-8 md:mt-0">
            <Box className="mr-4">
              <Box center className="rounded-lg  w-[44px] h-[44px] lg:w-[56px] lg:h-[56px] bg-white/5">
                <SynergyIcon />
              </Box>
            </Box>
            <Box>
              <Box className="mb-4 mt-3 uppercase font-bold text-[24px] leading-[24px] lg:text-[32px] lg:leading-[32px]">
                Synergize
              </Box>
              <Box className="lg:text-[14px] lg:leading-[22px]">
                Power up your gameplay with heroes: a roster of 5 and more heroes stationed within your parties will
                provide synergy in economic, and battle bonuses.
              </Box>
            </Box>
          </Box>
          <Box row className="mt-8 md:mt-0">
            <Box className="mr-4">
              <Box center className="rounded-lg  w-[44px] h-[44px] lg:w-[56px] lg:h-[56px] bg-white/5">
                <HeroIcon />
              </Box>
            </Box>
            <Box>
              <Box className="mb-4 mt-3 uppercase font-bold text-[24px] leading-[24px] lg:text-[32px] lg:leading-[32px]">
                Boost Your Battles
              </Box>
              <Box className="lg:text-[14px] lg:leading-[22px]">
                Bind a hero to your team to receive passive skill boosts! Fight in style with hero powers complementing
                your roster.
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
